import { FORM_PATHS, openInModalOrPage } from '../../modals';

export const CANCEL_MEETING_TYPE = 'CancelMeeting';

export const cancelMeeting = meeting => (dispatch, getState) => {
    dispatch(openInModalOrPage(FORM_PATHS.CancelMeetingModal, meeting.meetingId, meeting, meeting.startDate));
};
